import type { NskResponse } from "~/models/Api";
import { generatePath } from "~/utils/generatePath";
import { postRequest, putRequest } from "../api_handler";

export const create = async (email: string): Promise<NskResponse> =>
	postRequest(generatePath("/vendors/vendor_company_password_resets"), {
		email
	});

export const update = async (
	token: string,
	password: string
): Promise<NskResponse> =>
	putRequest(generatePath("/vendors/vendor_company_password_resets"), {
		password,
		token
	});
